import { useEffect, useMemo, useRef, useState } from 'react'
import { Autocomplete, TextField, CircularProgress } from '@mui/material'

// Autocomplete async reutilizable (typeahead). Reemplaza al <ui-select> de Qualita.
// fetcher: async (search) => array de items
export default function EntityAutocomplete({
  label,
  value,
  onChange,
  fetcher,
  getOptionLabel = (o) => o?.descripcion || o?.nombre || '',
  renderOption,
  disabled = false,
  required = false,
  error = false,
  helperText,
  minChars = 0,
  debounceMs = 350,
  size = 'small',
}) {
  const [open, setOpen] = useState(false)
  const [input, setInput] = useState('')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const timer = useState(() => ({ id: null }))[0]

  useEffect(() => {
    if (!open) return
    if (input.length < minChars) {
      setOptions([])
      return
    }
    setLoading(true)
    if (timer.id) clearTimeout(timer.id)
    timer.id = setTimeout(async () => {
      try {
        const res = await fetcher(input)
        const list = Array.isArray(res) ? res : res?.data || res?.list || []
        setOptions(list)
      } catch {
        setOptions([])
      } finally {
        setLoading(false)
      }
    }, debounceMs)
    return () => timer.id && clearTimeout(timer.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input, open])

  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={value || null}
      onChange={(_, v) => onChange(v)}
      onInputChange={(_, v) => setInput(v)}
      options={options}
      loading={loading}
      disabled={disabled}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(o, v) => o?.id === v?.id}
      filterOptions={(x) => x}
      renderOption={renderOption}
      noOptionsText={input.length < minChars ? `Escribí al menos ${minChars} caracteres` : 'Sin resultados'}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          size={size}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}
